import { render, staticRenderFns } from "./ItemTable.vue?vue&type=template&id=70a7c943&scoped=true&"
import script from "./ItemTable.vue?vue&type=script&lang=js&"
export * from "./ItemTable.vue?vue&type=script&lang=js&"
import style0 from "./ItemTable.vue?vue&type=style&index=0&id=70a7c943&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a7c943",
  null
  
)

export default component.exports